export enum Flaggers {
  GetGroupByNameFlagger = 'getGroupByNameFlagger',
  ExportClientReportFlagger = 'exportClientReportFlagger',
  LoginTokenFlagger = 'loginTokenFlagger',
  CheckGoogleAuthFlagger = 'checkGoogleAuthFlagger',
  ConfirmGooglePinFlagger = 'confirmGooglePinFlagger',
  SecurityPackageDetailsFlagger = 'SecurityPackageDetailsFlagger',
  SecurityPackageLoadingFlagger = 'SecurityPackageLoadingFlagger',
  MspInviteFlagger = 'MspInviteFlagger',
  RemovePortlandReportFlagger = 'RemovePortlandReportFlagger',
  AddProductModalFlagger = 'AddProductModalFlagger',
  AddMemberAccessModalFlagger = 'AddMemberAccessModalFlagger',
  DisableToggleTagModalFlagger = 'DisableToggleTagModalFlagger',
  DeleteTagModalFlagger = 'DeleteTagModalFlagger',
  PreviewInviteTemplateFlagger = 'PreviewInviteTemplateFlagger',
  AddPlanModalFlagger = 'AddPlanModalFlagger',
  RemovePracticeToolFlagger = 'RemovePracticeToolFlagger',
  AddToolsModalFlagger = 'AddToolsModalFlagger',
  UpdateToolModalFlagger = 'UpdateToolModalFlagger',
  UpdatePracticeModalFlagger = 'UpdatePracticeModalFlagger',
  DeleteCategoryModalFlagger = 'DeleteCategoryModalFlagger',
  DeleteCategoryPromptFlagger = 'DeleteCategoryPromptFlagger',
  DeleteCategoryFlagger = 'DeleteCategoryFlagger',
  ResetCategoryFlagger = 'ResetCategoryFlagger',
  UpdateTechSpendCategoryFlagger = 'UpdateTechSpendCategoryFlagger',
  RecalculateServicePackageScoreModalFlagger = 'RecalculateServicePackageScoreModalFlagger',
  RecalculateGovResScoreModalFlagger = 'RecalculateGovResScoreModalFlagger',
  ResetPasswordModalFlagger = 'ResetPasswordModalFlagger',
  ExtendTrialModalFlagger = 'ExtendTrialModalFlagger',
  ConvertSubscriptionModalFlagger = 'ConvertSubscriptionModalFlagger',
}
